import { api } from "../http";
import { pagination } from "../interfaces/baseinterface";
import {
  ActiveStudent,
  ApiResponse,
  RevenueData,
  Student,
  StudentEnquiry,
  Book,
  StudentPaymentRequest,
  UpcomingPayment,
} from "../types";
import {
 BookRegistrationData,
} from "../interfaces/BookInterface";






// Make sure `photo` is a File (from <input type="file">) in your StudentRegistrationData
export const registerBook = async (
  book: BookRegistrationData
): Promise<ApiResponse<string>> => {
  const form = new FormData();

  // Field names should match your C# model property names (case-insensitive for simple props)
  form.append("ISBN", book.ISBN);
  form.append("BookTitle", book.BookTitle);
  form.append("Author", book.Author);
  form.append("RFID", book.RFID);
 
  if (book.Price !== undefined) {
    form.append("Price", book.Price.toString());
  }

  if (book.AvailableCopies !== undefined) {
    form.append("AvailableCopies", book.AvailableCopies.toString());
  }
  
  // IMPORTANT: let Axios set the Content-Type with the boundary automatically
  const response = await api.post<ApiResponse<string>>(
    "/Book/BookRegistration",
    form
    // , { headers: { "Content-Type": "multipart/form-data" } } // optional, usually omit
  );

  return response.data;
};

export const getStudentValidation = async (
  field: string,
  value: string
): Promise<ApiResponse<number>> => {
  try {
    const response = await api.get<ApiResponse<number>>(
      `/Student/Validation?field=${field}&value=${value}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching student enquiries:", error);
    throw error;
  }
};


  
